import { Component, Input, Output, EventEmitter, ViewChild, ViewChildren, QueryList, ElementRef, AfterViewInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetInput } from '../../../Common/Models/widget.model';
import { Job } from '../../Models/job.model';
import { JobToJobListService } from '../../Services/ailike-jobs.service';
import { HtmlDecodePipe,SafeEmbedHtmlPipe} from '../../../Common/pipes/Angular-commonUtil.pipe';
import { TruncatePipe } from '../../../Common/pipes/truncate.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { TGLinksInfo, TgSettingsService } from 'app/services/TG-Setting_Services/tg-settings.service';

import { } from '@angular/cdk/a11y';




@Component({
  selector: 'job-job-list',
  standalone: true,
  imports: [CommonModule,HtmlDecodePipe, SafeEmbedHtmlPipe, TruncatePipe, TranslateModule],
  templateUrl: './job-to-joblist-widget.component.html',
  styleUrls: ['./job-to-joblist-widget.component.scss']
})

export class JobToJobListComponent implements AfterViewInit {
  TgSettings: any = {};
  pageType: string = '';
    constructor(private jobService: JobToJobListService, private tgSettingsService: TgSettingsService,private cdr: ChangeDetectorRef) {this.tgSettingsService.settings$.subscribe(settings => {
    this.TgSettings = settings?.tgSettings || {};
      this.cdr.markForCheck();
   }); }

  @Input() set widgetData(data: WidgetInput) {
    if (data) {
      this.pageType = data?.pagetype?.toLowerCase();
      if (data?.widgetType && data?.widgetType?.trim()?.toLowerCase() === 'profilematch')
      {
        this.widgetType = data.widgetType.trim().toLowerCase();
          this.profileMismatchMessage=data?.TranslateStrings?.["SmartRoleMismatch"]||'';
          this.checkResumeToJDScore(data);
          
      } else {
        this.loadJobs(data);
      }
    }
  }

  @Input() job: any;
  @Output() viewSimilarJobsBtn = new EventEmitter<boolean>();
  @Output() viewRelaventjobsJobsBtn = new EventEmitter<boolean>();
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('widgetHeading', { static: false }) widgetHeading!: ElementRef<HTMLElement>;
  @ViewChild('similarJobcardElement') card!: ElementRef<HTMLDivElement>;
  @ViewChildren('similarJobcardElement') cards!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChildren('similarJobcardElement') cardElements!: QueryList<ElementRef>;
  parmJob: any;
  widgetType: string = ''; 
  profileMismatchMessage: string = '';

  jobs: any[] = [];
  expandedJobIndex: number | null = null;
  isCarouselFocused = false;
  showLeftBtn = false;
  showRightBtn = true;
  totalCards = 0;
  visibleCards = 0;
  jobtojob:boolean= true;
  enableSocialReferral = true;
  resumeToJDScore: number | null = null;
  dialogAnnouncement: string = '';


  ngAfterViewInit(): void {
    this.cardElements.changes.subscribe(() => {
      setTimeout(() => {
        this.updateScrollButtons();
      }, 0);
    });
    setTimeout(() => {
      this.updateScrollButtons();
    }, 0);
    let scrollTimeout: any;
    this.scrollContainer?.nativeElement.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.updateScrollButtons(), 100);
    });
  }
  onScroll(): void {
    this.updateScrollButtons();
  }


  loadJobs(data: WidgetInput): void {
    if (data) {
      const appScope = (window as any).appScope;
      appScope.viewSimilarJobsBtn = false;
      appScope.viewRelaventjobsJobsBtn = false;
      this.viewSimilarJobsBtn.emit(false);
      this.viewRelaventjobsJobsBtn.emit(false);
      this.jobtojob=data.widgetType==''? true : false;
      this.jobs = [];
      this.TgSettings = data.tgsetting || {};
      let bruid=data.Bruid || appScope?.Abc||0 ;

      if(bruid >0 &&this.widgetType === 'profilematch'){
        bruid = "TG_" + data.partnerId + "_" + bruid;
      }
      data.sessionId = (data.sessionId == "" || data.sessionId == null || data.sessionId == undefined) ? ((document.getElementById("CookieValue") as HTMLInputElement)?.value || "") : data.sessionId;
      const requestPayload = {
        partnerId: +data.partnerId,
        siteId: +data.siteId,
        ReqId: +data.ReqId,
        sessionId: data.sessionId,
        turnOffHttps: false,
        profileId: bruid,
      };
      const currentWidgetType = this.widgetType;
      this.jobService.fetchJobs(requestPayload,currentWidgetType).subscribe({
        next: (res: Job[]) => {
          this.jobs = res || [];
          this.cdr.detectChanges(); // force *ngIf to render the heading before the timeout fires
          if (this.jobs.length > 0) {
            if (currentWidgetType === 'profilematch') {
              appScope.viewRelaventjobsJobsBtn = true;
              appScope.viewSimilarJobsBtn = false;
              this.viewRelaventjobsJobsBtn.emit(true);
              this.viewSimilarJobsBtn.emit(false);
            } else {
              appScope.viewSimilarJobsBtn = true;
              appScope.viewRelaventjobsJobsBtn = false;
              this.viewSimilarJobsBtn.emit(true);
              this.viewRelaventjobsJobsBtn.emit(false);
            }
            setTimeout(() => {
              const heading = this.widgetHeading?.nativeElement;
              if (heading) {
                heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                heading.focus();
              }
            }, 50);
          } else {
            appScope.viewSimilarJobsBtn = false;
            appScope.viewRelaventjobsJobsBtn = false;
            this.viewSimilarJobsBtn.emit(false);
            this.viewRelaventjobsJobsBtn.emit(false);
          }
        },
        error: (err: any) => {
          console.error('Failed to load jobs', err);
          appScope.viewSimilarJobsBtn = false;
          appScope.viewRelaventjobsJobsBtn = false;
          this.viewSimilarJobsBtn.emit(false);
          this.viewRelaventjobsJobsBtn.emit(false);
        }
      });
    }
  }

  private checkResumeToJDScore(data: WidgetInput): void {
    const requestPayload = {
      partnerId: String(data.partnerId),
      profileId: String("TG_" + data.partnerId + "_" + data.Bruid),
      jobId: String(data.ReqId)
    };
    const appScope = (window as any).appScope;
    this.jobService.getResumeToJDScore(requestPayload).subscribe({
      next: (response: any) => {
      const score = this.parseScore(response.data);
      this.resumeToJDScore = score;
      const threshold = Number(this.TgSettings.ResumeJobMatchthresholdScore) || 25;
      if (score !== null && score < threshold) {
       
        data.widgetType = 'profilematch';
        this.widgetType = 'profilematch';
        this.loadJobs(data);
      }
      else{
        appScope.viewRelaventjobsJobsBtn = false;
        this.viewRelaventjobsJobsBtn.emit(false);
        if((this.TgSettings.DisplaySimilarJobsonJobDetailView && this.pageType === 'jobdetail') || (this.TgSettings.DisplaySimilarJobsDuringApplyProcess && this.pageType === 'apply')){
          this.widgetType = 'similarjobs';
          this.loadJobs(data);
        }
      }
      
     
  
},
      error: (err: any) => {
        console.error('Failed to get ResumetoJD score', err);
        appScope.viewSimilarJobsBtn = false;
        appScope.viewRelaventjobsJobsBtn = false;
        this.viewSimilarJobsBtn.emit(false);
        this.viewRelaventjobsJobsBtn.emit(false);
      }
    });
  }

  private parseScore(scoreString: string): number | null {
    const parsedScore = parseFloat(scoreString);
    if (!isNaN(parsedScore)) {
      return parsedScore;
    }
    return null;
  }

  getJobCardAriaLabel(job: any, index: number): string {
    const rawTitle = this.extractJobFieldsFromQuestions(job.Questions).jobtitle || '';
    const div = document.createElement('div');
    div.innerHTML = rawTitle;
    const plainTitle = (div.textContent || div.innerText || '').trim();
    return `Job ${index + 1} of ${this.jobs.length}: ${plainTitle}`;
  }

  private announceDialog(message: string): void {
    this.dialogAnnouncement = '';
    this.cdr.markForCheck();
    setTimeout(() => {
      this.dialogAnnouncement = message;
      this.cdr.markForCheck();
      setTimeout(() => { this.dialogAnnouncement = ''; this.cdr.markForCheck(); }, 3000);
    }, 50);
  }

  handleClick($event: any, job: any, pagetype: 'apply'): void {
    console.log('Button clicked!');
    this.expandedJobIndex = null;
    //alert('Button was clicked!');
    const appScope = (window as any).appScope;
    appScope.ApplyFrmSimilarJobswidget($event, job, "apply");
  }
  extractJobFieldsFromQuestions(questions: any[]): {
    jobtitle: string;
    lastupdated: string;
    autoreq: string;
    jobdescription: string;
  } {
    const getValue = (name: string) =>
      questions.find(q => q.QuestionName === name)?.Value || '';

    return {
      jobtitle: getValue('jobtitle'),
      lastupdated: getValue('lastupdated'),
      autoreq: getValue('autoreq'),
      jobdescription: getValue('jobdescription')
    };
  }
  onJobTitleClickFromMouse(event: MouseEvent, job: any, jobId: string): void {
    this.onJobTitleClick(event, job, jobId);
  }
  onJobTitleClickFromKeyboard(event: Event, job: any, jobId: string): void {
    const keyEvent = event as KeyboardEvent;
    if (keyEvent.key === 'Enter') {
      this.onJobTitleClick(keyEvent, job, jobId);
    }
  }

  private onJobTitleClick(event: MouseEvent | KeyboardEvent, job: any, jobId: string): void {
    if (event instanceof KeyboardEvent && event.key !== 'Enter') return;
    const appScope = (window as any).appScope;
    appScope.job = job;
    appScope.jobs = this.jobs;

    if (appScope?.handlers?.jobTitle) {
      appScope.handlers.jobTitle(appScope, false, jobId);
    } else {
      console.error('jobTitle handler not found on appScope');
    }
  }

  toggleReadMore(index: number, job: any): void {
    this.expandedJobIndex = index;
    this.parmJob = job;
    setTimeout(() => {
      const modal = document.querySelector<HTMLElement>('.readmore-modal');
      if (!modal) return;
      // Focus the title h1 directly — SR reads the job title heading instead of announcing "close button"
      const modalTitle = modal.querySelector<HTMLElement>('#modalTitle');
      (modalTitle ?? modal).focus();
      const focusables = modal.querySelectorAll<HTMLElement>('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const first = focusables[0] ?? null;
      const last  = focusables[focusables.length - 1] ?? null;
      modal.onkeydown = (e: KeyboardEvent) => {
        if (e.key === 'Tab' && first && last) {
          setTimeout(() => {
            if (!modal.contains(document.activeElement)) (e.shiftKey ? last : first).focus();
          }, 1);
        }
      };
    }, 50);
  }

  closeReadMore(): void {
    const index = this.expandedJobIndex;
    if (index === null) return;
    this.expandedJobIndex = null;
    this.announceDialog('Job details dialog closed.');
    setTimeout(() => {
      const cards = this.cardElements?.toArray();
      if (!cards?.length) return;
      const targetCard = cards[index] ?? cards[0];
      const focusTarget = targetCard?.nativeElement?.querySelector('a, button') as HTMLElement | null;
      if (focusTarget) {
        focusTarget.focus();
        targetCard.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 200); // 200ms lets the "dialog closed" live region play before focus moves to the card
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  showRenderedFields(questions: any[]): any[] {
    return questions?.filter(q => !!q?.ClassName);
  }
  displayRenderedFields(aoFields: any[]) {
    return HtmlDecodePipe.displayRenderedFields(aoFields);
  }
 // @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateScrollButtons();
  }


  checkHotJob(job: any): boolean {
    const hotJobValue = job?.Questions?.find((q: any) => q.QuestionName === 'hotjob')?.Value;
    return (hotJobValue || '').toString().toLowerCase() === 'yes';
  }

  handlers = {
    jobClick: (event: MouseEvent, job: any) => {
    }
  };

  scrollLeft(): void {
    this.scrollByVisibleCards(-1);
    setTimeout(() => this.updateScrollButtons(), 500);
  }

  scrollRight(): void {
    this.scrollByVisibleCards(1);
    setTimeout(() => this.updateScrollButtons(), 500);
  }

  updateScrollButtons(): void {
    const container = this.scrollContainer?.nativeElement;
    if (!container) {
      this.showLeftBtn = false;
      this.showRightBtn = false;
      return;
    }
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const containerWidth = container.clientWidth;
    const buffer = 1;
    const isScrollable = scrollWidth > containerWidth + buffer;
    if (!isScrollable) {
      this.showLeftBtn = false;
      this.showRightBtn = false;
      return;
    }
    this.showLeftBtn = scrollLeft > buffer;
    this.showRightBtn = (scrollLeft + containerWidth) < (scrollWidth - buffer);
  }

  scrollByVisibleCards(direction: 1 | -1): void {
    const container = this.scrollContainer?.nativeElement;
    const card = this.card?.nativeElement;
    if (!container || !card) return;

    const containerWidth = container.clientWidth;
    const cardStyle = getComputedStyle(card);
    const cardMarginRight = parseFloat(cardStyle.marginRight) || 0;
    const cardWidth = card.offsetWidth + cardMarginRight;
    let scrollStep: number;
    // Mobile: scroll by 1 card, Desktop: scroll by visible card count
    if (window.innerWidth <= 768) {
      scrollStep = cardWidth;
    } else {
      const visibleCards = Math.floor(containerWidth / cardWidth);
      scrollStep = visibleCards * cardWidth;
    }
    const newScroll = Math.max(
      0,
      Math.min(container.scrollLeft + direction * scrollStep, container.scrollWidth - containerWidth)
    );
    animateScroll(container, newScroll, 500);
  }

}
function animateScroll(element: HTMLElement, to: number, duration: number) {
  const start = element.scrollLeft;
  const change = to - start;
  const startTime = performance.now();
  const prevSnapType = element.style.scrollSnapType;
  element.style.scrollSnapType = 'none';

  function easeInOutQuad(t: number): number {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;  // 👈 Make end softer
  }

  function animate(time: number) {
    const currentTime = (time - startTime) / duration;
    const easedTime = easeInOutQuad(Math.min(currentTime, 1));
    element.scrollLeft = start + change * easedTime;
    if (currentTime < 1) {
      requestAnimationFrame(animate);
    } else {
      element.style.scrollSnapType = prevSnapType;
      element.scrollLeft = to;
    }
  }
  requestAnimationFrame(animate);
}
